module.exports = __webpack_public_path__ + "media/music/punchy_bass_6-5cbb905e.mp3";